import React from "react";

const ImageGallery = ({ images }) => {
  const columns = [[], [], [], []];
  images.forEach((image, index) => {
    columns[index % 4].push(image);
  });

  return (
    <div className="w-4/5 md:w-2/5 mx-auto grid grid-cols-4 md:grid-cols-4 gap-4 overflow-x-hidden-hidden items-center h-min sm:h-96">
      {columns.map((column, colIndex) => (
        <div key={colIndex} className="flex flex-col gap-4">
          {column.map((image, imgIndex) => (
            <img
              key={imgIndex}
              className="w-full h-auto rounded-lg object-cover"
              src={image}
              alt={`Gallery image ${colIndex}-${imgIndex}`}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
